import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_PREFIX = 'neorag_infobox_';

export default function InfoBox({ tabKey, children }) {
  const { t } = useTranslation();
  const storageKey = `${STORAGE_PREFIX}${tabKey}`;
  const [open, setOpen] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored === '1';
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    try { localStorage.setItem(storageKey, open ? '1' : '0'); } catch (_) {}
  }, [open, storageKey]);

  const prefix = `traceability:infobox.${tabKey}`;

  return (
    <div className="mb-4 rounded-md border border-border-subtle bg-surface-raised/60">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-2 text-label tracking-widest text-ink-secondary hover:text-accent-text transition-colors"
        aria-expanded={open}
        title={t('traceability:infobox.toggle')}
      >
        <span>ⓘ · {t('traceability:infobox.what')}</span>
        <span className="text-ink-muted">{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div className="px-4 pb-4 text-sm text-ink-secondary space-y-3 border-t border-border-subtle pt-3">
          <Section
            heading={t('traceability:infobox.what')}
            body={t(`${prefix}.what`)}
          />
          <Section
            heading={t('traceability:infobox.source')}
            body={t(`${prefix}.source`)}
          />
          <Section
            heading={t('traceability:infobox.interpret')}
            body={t(`${prefix}.interpret`)}
          />
          <Section
            heading={t('traceability:infobox.filters')}
            body={t(`${prefix}.filters`)}
          />
          {children}
        </div>
      )}
    </div>
  );
}

function Section({ heading, body }) {
  return (
    <div>
      <div className="text-label tracking-widest text-ink-muted uppercase mb-1">
        {heading}
      </div>
      <div className="leading-relaxed whitespace-pre-line">{body}</div>
    </div>
  );
}
